import React from 'react';
import { Box, Flex, HStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { Nav, PageHeader } from '../../styles/layoutDimensions';
import ChildrenType from '../../types/ChildrenType';

import LogoBox from './LogoBox';
import ToggleNavBox from './ToggleNavBox';

const Header = ({ children, logoLinkHref, handleNavClick, isNavOpen }) => (
  <Flex
    alignItems="center"
    bg="white"
    height={PageHeader.height}
    justifyContent="space-between"
    position="sticky"
    pr={6}
    width="100%"
    zIndex={2}
  >
    <Flex alignItems="center" width={Nav.expandedWidth}>
      <ToggleNavBox isOpen={isNavOpen} onClick={handleNavClick} />
      <Box margin="auto">
        <LogoBox to={logoLinkHref} />
      </Box>
    </Flex>
    <HStack alignItems="center" spacing={5}>
      {children}
    </HStack>
  </Flex>
);

Header.propTypes = {
  children: ChildrenType,
  logoLinkHref: PropTypes.string,
  handleNavClick: PropTypes.func,
  isNavOpen: PropTypes.bool
};

export default Header;
